module.exports = "/_next/static/images/GOER-Djimi-4d1bdf47e4b0e3a4cb9e003de40d4fa4.svg";